import { DataService } from '../../../shared/services/data.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Asset } from '../models/asset';
import { SystemAlertDto } from 'src/app/internal-user/notifications/models/system-alert-dto';

@Injectable({
  providedIn: 'root',
})
export class SystemAlertService extends DataService<undefined> {

  httpClient: HttpClient;

  constructor(http: HttpClient) {
    super(`${environment.apiUrl.authorizationService}system-health/`, http);
    this.httpClient = http;
  }

  getSubscribedAssets(): Observable<Asset[]> { return this.http.get<any[]>(`${this.url}subscriptions`); }

  getAlertsTopLevel(): Observable<SystemAlertDto[]> { return this.http.get<any[]>(`${this.url}alerts`)}

  updateSubscription(systemId: string, systemType: string, enable: boolean)
  {
    return this.http.put(`${this.url}subscription`, {
        systemId: systemId,
        systemType: systemType,
        enable: enable
    });
  }

  createAcknowledgement(alertId: string, ackType: string, details: string) {
    return this.http.post(`${this.url}ack`, {
      alertId: alertId,
      ackType: ackType,
      details: details
    });
  }
}
